import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useLocalStorage} from 'react-use';
import MinutesInfo from './Info.js';
import MinutesHeader from './Header.js';
import {
  Button,
  Col,
  Form,
  Modal,
  Row
} from 'react-bootstrap';

function Admin({onHide, onSubmit, schedule}) {

  const [auth] = useLocalStorage('authenticated');
  const [note, setNote] = useState(``);
  const [id, setId] = useState(null);
  const [statement, setStatement] = useState(``);

  const fetchMinutes = async () => {

    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_HOST}schedules/${schedule.SCHEDULE_ID}`,
        {
          params: {expand: 'minutes'},
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      setNote(response.data?.minutes?.AUDITOR_NOTE);
      setId(response.data?.minutes?.MINUTES_ID);

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  };

  useEffect(() => {
    fetchMinutes();
  }, []);

  return (
    <Modal
      size="lg"
      show={true}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/* <MinutesHeader /> */}
      <Modal.Header >
        <Modal.Title id="example-modal-sizes-title-lg">Minutes of Audit</Modal.Title>
        <button type="button" class="close" onClick={onHide}>&times;</button>
      </Modal.Header>
      <Modal.Body>
        <MinutesInfo schedule={schedule} />
        <hr/>
        <Row>
          <Col md="12">
            <Form.Group>
              <Form.Label>Auditor's General Statement*:</Form.Label>
              <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: note}} />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Form.Group>
              <Form.Label>BPMI General Statement*:</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={statement}
                onChange={({target: {value}}) => setStatement(value)}
                isInvalid={statement?.length > 4000}
              />
              <Form.Text id="passwordHelpBlock" muted>
                Total characters: {statement?.length ?? 0} / 4000
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer style={{justifyContent: 'flex-end', gap: '10px'}}>
        <Button onClick={() => onSubmit(statement, id)} variant="primary">Approve</Button>
        <Button onClick={onHide} variant="secondary">Close</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default Admin;